module.exports = __webpack_public_path__ + "static/media/MANAS 1.98ca20e3.png";